import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "md-progress-spinner md-progress-spinner-indeterminate md-indeterminate md-theme-default" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "50%",
  cy: "50%",
  r: "27",
  class: "md-progress-spinner-circle",
  style: {"stroke-dasharray":"169.646px","stroke-width":"6px","--md-progress-spinner-start-value":"161.16370312915637","--md-progress-spinner-end-value":"33.929200658769766"}
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock("svg", {
      preserveAspectRatio: "xMidYMid meet",
      focusable: "false",
      viewBox: "0 0 60 60",
      class: "md-progress-spinner-draw",
      style: _normalizeStyle(_ctx.customStyle)
    }, _hoisted_3, 4))
  ]))
}